interface WindowEnv {
  __ENV__?: {
    API_URL?: string;
    DEFAULT_MAXIMUM_NUMBER_OF_LAYERS?: string;
    DEFAULT_CENTROID_LATITUDE?: string;
    DEFAULT_CENTROID_LONGITUDE?: string;
    COGNITO_USER_POOL_ID?: string;
    COGNITO_REGION?: string;
    COGNITO_CLIENT_ID?: string;
  };
}

declare global {
  interface Window extends WindowEnv {}
}

// 개발 환경인지 감지 (localhost 사용 여부로 판단)
const isDevelopment = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';

export default {
  api: {
    url: isDevelopment 
      ? 'http://localhost:5001/api'  // 개발 환경
      : (window.__ENV__?.API_URL || 'https://backend.zeroth.link/api'), // 프로덕션 환경
  },
  map: {
    defaultMaximumNumberOfLayers: parseInt(
      window.__ENV__?.DEFAULT_MAXIMUM_NUMBER_OF_LAYERS || '1000',
      10,
    ),
    defaultCentroid: {
      lat: parseFloat(
        window.__ENV__?.DEFAULT_CENTROID_LATITUDE || '37.53350339318236',
      ),
      lng: parseFloat(
        window.__ENV__?.DEFAULT_CENTROID_LONGITUDE || '126.88308094746908',
      ),
    },
  },
  cognito: {
    userPoolId: window.__ENV__?.COGNITO_USER_POOL_ID || 'ap-northeast-2_HaJu55vxN',
    region: window.__ENV__?.COGNITO_REGION || 'ap-northeast-2',
    clientId: window.__ENV__?.COGNITO_CLIENT_ID || 'ue3jibiiur7jr4979ccefp1ri',
  },
};
